// Local browser storage helpers for TYPE ELITE.
const K = {
  PROJECTS: 'te.projects',
  FAVORITES: 'te.favorites',
  HISTORY: 'te.history',
  PALETTES: 'te.palettes',
  CUSTOM_PALETTES: 'te.customPalettes',
  CUSTOM_GRADIENTS: 'te.customGradients',
  CUSTOM: 'te.customOptions',
  CURRENT: 'te.current',
  TIPS_SEEN: 'te.tipsSeen',
};

function safeGet(k, fallback) {
  try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : fallback; }
  catch { return fallback; }
}
function safeSet(k, v) {
  try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch { return false; }
}

export const storage = {
  listProjects: () => safeGet(K.PROJECTS, []),
  saveProject: (project) => {
    const projects = safeGet(K.PROJECTS, []);
    const idx = projects.findIndex((p) => p.id === project.id);
    if (idx >= 0) projects[idx] = project; else projects.unshift(project);
    return safeSet(K.PROJECTS, projects);
  },
  deleteProject: (id) => {
    const projects = safeGet(K.PROJECTS, []).filter((p) => p.id !== id);
    return safeSet(K.PROJECTS, projects);
  },
  addHistory: (entry) => {
    const h = safeGet(K.HISTORY, []);
    h.unshift(entry);
    return safeSet(K.HISTORY, h.slice(0, 200));
  },
  listHistory: () => safeGet(K.HISTORY, []),
  toggleFavorite: (id) => {
    const favs = safeGet(K.FAVORITES, []);
    const next = favs.includes(id) ? favs.filter((x) => x !== id) : [...favs, id];
    safeSet(K.FAVORITES, next);
    return next;
  },
  listFavorites: () => safeGet(K.FAVORITES, []),
  setCurrent: (p) => safeSet(K.CURRENT, p),
  getCurrent: () => safeGet(K.CURRENT, null),
  markTipsSeen: () => safeSet(K.TIPS_SEEN, true),
  tipsSeen: () => !!safeGet(K.TIPS_SEEN, false),
  // Custom palettes (named, editable, local)
  listCustomPalettes: () => safeGet(K.CUSTOM_PALETTES, []),
  saveCustomPalette: (palette) => {
    const list = safeGet(K.CUSTOM_PALETTES, []);
    const idx = list.findIndex((p) => p.id === palette.id);
    if (idx >= 0) list[idx] = palette; else list.unshift(palette);
    return safeSet(K.CUSTOM_PALETTES, list);
  },
  deleteCustomPalette: (id) => safeSet(K.CUSTOM_PALETTES, safeGet(K.CUSTOM_PALETTES, []).filter((p) => p.id !== id)),
  // Custom gradients (named, editable, local)
  listCustomGradients: () => safeGet(K.CUSTOM_GRADIENTS, []),
  saveCustomGradient: (grad) => {
    const list = safeGet(K.CUSTOM_GRADIENTS, []);
    const idx = list.findIndex((g) => g.id === grad.id);
    if (idx >= 0) list[idx] = grad; else list.unshift(grad);
    return safeSet(K.CUSTOM_GRADIENTS, list);
  },
  deleteCustomGradient: (id) => safeSet(K.CUSTOM_GRADIENTS, safeGet(K.CUSTOM_GRADIENTS, []).filter((g) => g.id !== id)),
  exportProject: (project) => {
    const blob = new Blob([JSON.stringify(project, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `type-elite-${(project.name || 'project').replace(/\s+/g, '-')}.json`;
    a.click();
    URL.revokeObjectURL(url);
  },
  downloadText: (text, filename) => {
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'type-elite-prompt.txt';
    a.click();
    URL.revokeObjectURL(url);
  },
};

export const genId = () => (crypto?.randomUUID ? crypto.randomUUID() : `p_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`);
